import React, { useContext, useState } from "react";
import { NavPage } from "../../services/NavService";
import { DoorImage } from "./DoorImage";
import { EditorNav } from "../EditorNav/EditorNav";
import { TopNav } from "../TopNav/TopNav";
import { AllDoorsEditor } from "./AllDoorsEditor";
import { SingleDoorEditor } from "./SingleDoorEditor";
import "../../style/editor.scss";
import { GableSide } from "../../models/GableSide";
import { SingleGableEditor } from "./SingleGableEditor";
import { EditorContext } from "../EditorCommon/EditorContext";


type EditorType =
    { type: "door", doorIndex: number } //show a door editor
    | { type: "gable", gableSide: GableSide } //show a gable editor
    | undefined; //Don't show an editor

export function DoorEditor() {

    const ec = useContext(EditorContext);

    const [showEditor, setShowEditor] = useState<EditorType>(undefined);

    function onClickDoor(doorIndex: number) {
        setShowEditor({ type: "door", doorIndex: doorIndex });
    }
    function onClickGable(gableSide: GableSide) {
        setShowEditor({ type: "gable", gableSide: gableSide })
    }

    return (
        <div className="editor ext-editor door-editor ">

            <TopNav header={ec.translator("doorEditor header", "Døre") } />

            <div className="left-toolbox">
                <AllDoorsEditor />
            </div>

            <DoorImage className="main-editor"
                onClickDoor={onClickDoor}
                onClickGable={onClickGable}
            />

            <div className="right-toolbox">
                {showEditor?.type === "door" && (
                    <SingleDoorEditor
                        doorIndex={showEditor.doorIndex}
                        onClose={() => setShowEditor(undefined)}
                    />
                )}
                {showEditor?.type === "gable" && (
                    <SingleGableEditor
                        gableSide={showEditor.gableSide}
                        onClose={() => setShowEditor(undefined)}
                    />
                )}
            </div>

            <EditorNav currentPage={NavPage.Doors} />
        </div>

    );
}
